import { render, staticRenderFns } from "./ToggleMode.vue?vue&type=template&id=34455472&scoped=true&"
import script from "./ToggleMode.vue?vue&type=script&lang=js&"
export * from "./ToggleMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34455472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34455472')) {
      api.createRecord('34455472', component.options)
    } else {
      api.reload('34455472', component.options)
    }
    module.hot.accept("./ToggleMode.vue?vue&type=template&id=34455472&scoped=true&", function () {
      api.rerender('34455472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToggleMode.vue"
export default component.exports